module.exports = __webpack_public_path__ + "static/orders-resume-md-65d968de4b5c3c1931c9f7de66f360f8.png";